import { Close } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { PAYMENTS_MODAL_STYLES } from "../../styles/styles";

export default function PaymentsTextField(props) {
  const {
    fieldName,
    fieldValue,
    onChange,
    inputMode = "text",
    pattern,
    type = "text",
    maxDigits,
    validator,
  } = props;

  const handleChange = (event) => {
    const { value } = event.target;
    const digitsOnly = value.replace(/\D/g, "");

    if (pattern && !pattern.test(value)) {
      return;
    }

    if (maxDigits && digitsOnly.length > maxDigits) {
      return;
    }

    if (validator && !validator(value)) {
      return;
    }

    onChange(fieldName, value);
  };

  return (
    <TextField
      className="w-full"
      size="small"
      type={type}
      value={fieldValue}
      onChange={handleChange}
      sx={PAYMENTS_MODAL_STYLES.textField}
      inputProps={{ inputMode }}
      InputProps={{
        endAdornment: fieldValue ? (
          <InputAdornment position="end" className="p-2">
            <IconButton edge="end" size="small" onClick={() => onChange(fieldName, "")}>
              <Close fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
